<div class="banner-container-wrapper" [ngClass]="{'full-width': listaBanners.length >= 4}" cdkScrollable>
  <div 
    cdkDropList 
    cdkDropListOrientation="horizontal" 
    class="banner-list" 
    [cdkDropListAutoScrollStep]="35" 
    (cdkDropListDropped)="drop($event)">
    
    <div 
      class="banner-box" 
      *ngFor="let banner of listaBanners; let i = index" 
      cdkDrag>
      
      <div class="banner-content" [style.--bg-image]="'url(' + banner.urlIcono + ')'">
        <span class="banner-badge">{{ i + 1 }}</span>
        <span *ngIf="banner.idSector === 5" class="banner-sector-title"> Funciones </span>
      </div>

      <div class="banner-placeholder" *cdkDragPlaceholder></div>
    </div>

  </div>
</div>